import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalRedeemCouponPageRoutingModule } from './modal-redeem-coupon-routing.module';

import { ModalRedeemCouponPage } from './modal-redeem-coupon.page';
//Components
import { ComponentsModule } from 'src/app/components/components.module'
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ComponentsModule,
    MatCheckboxModule,
    ModalRedeemCouponPageRoutingModule
  ],
  declarations: [ModalRedeemCouponPage]
})
export class ModalRedeemCouponPageModule {}
